import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({ name: 'dateFormat' })
export class DateFormatPipe implements PipeTransform {
  transform(value: string) {
    const datePipe = new DatePipe('en-US');
    return datePipe.transform(value, 'MMM, y');
    // return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/date-pipe.ts